import {
  FieldValue,
  serverTimestamp,
  Timestamp,
} from '@angular/fire/firestore';

export const toDate = (
  timestamp: Timestamp | FieldValue | null | undefined
): Date => {
  if (!timestamp) {
    throw new Error('Timestamp is required for date conversion');
  }

  if (timestamp instanceof Timestamp) {
    return timestamp.toDate();
  }

  // Must accept FieldValue, but its only used in saving not loading, so shouln't actually be passed in
  throw new Error(
    'Unexpected FieldValue passed to toDate. Ensure this function is used only with Timestamp values.'
  );
};

export const toTimestamp = (
  date: Date | null | undefined
): Timestamp | FieldValue => {
  if (!date) {
    return serverTimestamp();
  }

  return Timestamp.fromDate(date);
};
